import {ServiceNumberData} from '@gt-api';
import {MockData} from '@testhelper/mock-data';

export class ServiceNumberDataMock {
  static getServiceNumberData(): ServiceNumberData[] {
    return [
      {
        serviceNumber: {
          number: '4778974973',
          name: 'Hovednummer',
          pattern: '1'
        },
        queueData: []
      },
      {
        serviceNumber: {
          number: '4778974989',
          name: 'Svargruppe',
          pattern: '2'
        },
        queueData: [
          {
            serviceNumber: '4778974989',
            cid: 0,
            name: 'Svargruppe',
            maxPositions: 10,
            maxTime: null,
            checkFrequency: 30,
            kickoutTime: 600,
            kickoutNoAgents: 120,
            displayUpdateFrequency: 30,
            type: 3,
            calls: 0,
            activeCalls: 0,
            agentsAvailable: 0,
            queueAgents: [
              {
                organization: MockData.organization,
                login: MockData.login,
                firstName: null,
                lastName: 'Test User 2156',
                phoneNumber: '479997',
                serviceNumber: '4778974989',
                cid: 0,
                state: 0,
                active: false,
                skillLevel: 10,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '46170740',
                firstName: 'Per',
                lastName: 'Sonli',
                phoneNumber: '4746170740',
                serviceNumber: '4778974989',
                cid: 0,
                state: 1,
                active: false,
                skillLevel: 11,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '41563151',
                firstName: 'Håvard',
                lastName: 'priv',
                phoneNumber: '4741563151',
                serviceNumber: '4778974989',
                cid: 0,
                state: 1,
                active: true,
                skillLevel: 12,
                noReplyTime: 20,
                wrapupTime: 0
              }
            ]
          },
          {
            serviceNumber: '4778974989',
            cid: 3,
            name: 'Ventekø',
            maxPositions: 10,
            maxTime: null,
            checkFrequency: 30,
            kickoutTime: 600,
            kickoutNoAgents: 9999,
            displayUpdateFrequency: 30,
            type: 3,
            calls: 0,
            activeCalls: 0,
            agentsAvailable: 0,
            queueAgents: []
          },
          {
            serviceNumber: '4778974989',
            cid: 39,
            name: 'CallbackQueue',
            maxPositions: 5,
            maxTime: null,
            checkFrequency: 0,
            kickoutTime: 0,
            kickoutNoAgents: 0,
            displayUpdateFrequency: 0,
            type: 32,
            calls: 0,
            activeCalls: 0,
            agentsAvailable: 1,
            queueAgents: [
              {
                organization: MockData.organization,
                login: '41563151',
                firstName: 'Håvard',
                lastName: 'priv',
                phoneNumber: '4741563151',
                serviceNumber: '4778974989',
                cid: 39,
                state: 1,
                active: false,
                skillLevel: 3,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '46170740',
                firstName: 'Per',
                lastName: 'Sonli',
                phoneNumber: '4746170740',
                serviceNumber: '4778974989',
                cid: 39,
                state: 1,
                active: false,
                skillLevel: 2,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: MockData.login,
                firstName: null,
                lastName: 'Test User 2156',
                phoneNumber: '479997',
                serviceNumber: '4778974989',
                cid: 39,
                state: 1,
                active: true,
                skillLevel: 1,
                noReplyTime: 20,
                wrapupTime: 0
              }
            ]
          }
        ]
      },
      {
        serviceNumber: {
          number: '99599598',
          name: 'Hovednummer',
          pattern: '1'
        },
        queueData: []
      },
      {
        serviceNumber: {
          number: '99599599',
          name: 'Svargruppe',
          pattern: '2'
        },
        queueData: [
          {
            serviceNumber: '99599599',
            cid: 0,
            name: 'Svargruppe',
            maxPositions: 10,
            maxTime: null,
            checkFrequency: 30,
            kickoutTime: 600,
            kickoutNoAgents: 120,
            displayUpdateFrequency: 30,
            type: 3,
            calls: 0,
            activeCalls: 0,
            agentsAvailable: 0,
            queueAgents: []
          },
          {
            serviceNumber: '99599599',
            cid: 3,
            name: 'Ventekø',
            maxPositions: 10,
            maxTime: null,
            checkFrequency: 30,
            kickoutTime: 600,
            kickoutNoAgents: 9999,
            displayUpdateFrequency: 30,
            type: 3,
            calls: 0,
            activeCalls: 0,
            agentsAvailable: 0,
            queueAgents: []
          },
          {
            serviceNumber: '99599599',
            cid: 39,
            name: 'TEST',
            maxPositions: 5,
            maxTime: null,
            checkFrequency: 0,
            kickoutTime: 0,
            kickoutNoAgents: 0,
            displayUpdateFrequency: 0,
            type: 3,
            calls: 0,
            activeCalls: 0,
            agentsAvailable: 0,
            queueAgents: [
              {
                organization: MockData.organization,
                login: MockData.login,
                firstName: null,
                lastName: 'Test User 2156',
                phoneNumber: '479997',
                serviceNumber: '99599599',
                cid: 39,
                state: 1,
                active: true,
                noReplyTime: 20,
                wrapupTime: 0
              }
            ]
          }
        ]
      },
      {
        serviceNumber: {
          number: '4722535028',
          name: 'Hoved IMG Hoved IMG 22535028',
          pattern: '1'
        },
        queueData: []
      },
      {
        serviceNumber: {
          number: '4722535028007',
          name: 'Screening',
          pattern: '9'
        },
        queueData: []
      },
      {
        serviceNumber: {
          number: '4722535028008',
          name: 'Screening',
          pattern: '9'
        },
        queueData: []
      },
      {
        serviceNumber: {
          number: '4723905197',
          name: 'Hovednummer',
          pattern: '1'
        },
        queueData: []
      },
      {
        serviceNumber: {
          number: '4737179231',
          name: 'Mainnumber',
          pattern: '1'
        },
        queueData: []
      },
      {
        serviceNumber: {
          number: '4737179231001',
          name: 'Tastevalg 1',
          pattern: '7'
        },
        queueData: []
      },
      {
        serviceNumber: {
          number: '4737179231001001',
          name: 'Tastevalg 3',
          pattern: '7'
        },
        queueData: []
      },
      {
        serviceNumber: {
          number: '4737179231001002',
          name: 'VIP-liste',
          pattern: '9'
        },
        queueData: []
      },
      {
        serviceNumber: {
          number: '4737179231001003',
          name: 'VIP-liste',
          pattern: '9'
        },
        queueData: []
      },
      {
        serviceNumber: {
          number: '4737179231001004',
          name: 'VIP-liste',
          pattern: '9'
        },
        queueData: []
      },
      {
        serviceNumber: {
          number: '4737179231002',
          name: 'Tastevalg_78403123',
          pattern: '7'
        },
        queueData: []
      },
      {
        serviceNumber: {
          number: '4737179231003',
          name: 'Tastevalg 5',
          pattern: '7'
        },
        queueData: []
      },
      {
        serviceNumber: {
          number: '4744556677',
          name: 'Test-MH',
          pattern: '1'
        },
        queueData: []
      },
      {
        serviceNumber: {
          number: '47580002020998',
          name: '12-digit-AG',
          pattern: '2'
        },
        queueData: [
          {
            serviceNumber: '47580002020998',
            cid: 0,
            name: '12-digit-AG',
            maxPositions: 0,
            maxTime: 0,
            checkFrequency: 30,
            kickoutTime: 600,
            kickoutNoAgents: 120,
            displayUpdateFrequency: 30,
            type: 3,
            calls: 0,
            activeCalls: -1,
            maxWaitTime: 0,
            agentsLoggedIn: 0,
            agentsAvailable: 0,
            queueAgents: [
              {
                organization: MockData.organization,
                login: '91905129',
                firstName: 'Volte4',
                lastName: 'Staging',
                phoneNumber: null,
                serviceNumber: '47580002020998',
                cid: 0,
                state: 0,
                active: false,
                skillLevel: 1,
                noReplyTime: 20,
                wrapupTime: 0
              }
            ]
          },
          {
            serviceNumber: '47580002020998',
            cid: 3,
            name: 'Holdqueue',
            maxPositions: 0,
            maxTime: 0,
            checkFrequency: 30,
            kickoutTime: 600,
            kickoutNoAgents: 9999,
            displayUpdateFrequency: 30,
            type: 3,
            calls: 0,
            activeCalls: -1,
            maxWaitTime: 0,
            agentsLoggedIn: 0,
            agentsAvailable: 0,
            queueAgents: []
          },
          {
            serviceNumber: '47580002020998',
            cid: 39,
            name: 'CallbackQueue',
            maxPositions: 0,
            maxTime: 0,
            checkFrequency: 0,
            kickoutTime: 0,
            kickoutNoAgents: 0,
            displayUpdateFrequency: 0,
            type: 32,
            calls: 0,
            activeCalls: -1,
            maxWaitTime: 0,
            agentsLoggedIn: 0,
            agentsAvailable: 0,
            queueAgents: [
              {
                organization: MockData.organization,
                login: '91905129',
                firstName: 'Volte4',
                lastName: 'Staging',
                phoneNumber: null,
                serviceNumber: '47580002020998',
                cid: 39,
                state: 0,
                active: false,
                skillLevel: 1,
                noReplyTime: 20,
                wrapupTime: 0
              }
            ]
          }
        ]
      },
      {
        serviceNumber: {
          number: '4770238717',
          name: 'Ninja1',
          pattern: '2'
        },
        queueData: [
          {
            serviceNumber: '4770238717',
            cid: 0,
            name: 'Ninja1',
            maxPositions: 0,
            maxTime: 0,
            checkFrequency: 30,
            kickoutTime: 600,
            kickoutNoAgents: 120,
            displayUpdateFrequency: 30,
            type: 3,
            calls: 0,
            activeCalls: -1,
            maxWaitTime: 0,
            agentsLoggedIn: 0,
            agentsAvailable: 0,
            queueAgents: [
              {
                organization: MockData.organization,
                login: '91902156',
                firstName: 'User_2156',
                lastName: 'Test',
                phoneNumber: null,
                serviceNumber: '4770238717',
                cid: 0,
                state: 0,
                active: true,
                skillLevel: 6,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '91903248',
                firstName: 'Test_3248',
                lastName: 'user',
                phoneNumber: '4791903248',
                serviceNumber: '4770238717',
                cid: 0,
                state: 1,
                active: false,
                skillLevel: 1,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '91903934',
                firstName: 'Test_3934',
                lastName: 'User',
                phoneNumber: null,
                serviceNumber: '4770238717',
                cid: 0,
                state: 0,
                active: false,
                skillLevel: 5,
                noReplyTime: 20,
                wrapupTime: 20
              }
            ]
          },
          {
            serviceNumber: '4770238717',
            cid: 3,
            name: 'Holdqueue',
            maxPositions: 0,
            maxTime: 0,
            checkFrequency: 30,
            kickoutTime: 600,
            kickoutNoAgents: 9999,
            displayUpdateFrequency: 30,
            type: 3,
            calls: 0,
            activeCalls: -1,
            maxWaitTime: 0,
            agentsLoggedIn: 0,
            agentsAvailable: 0,
            queueAgents: []
          },
          {
            serviceNumber: '4770238717',
            cid: 39,
            name: 'CallbackQueue',
            maxPositions: 0,
            maxTime: 0,
            checkFrequency: 0,
            kickoutTime: 0,
            kickoutNoAgents: 0,
            displayUpdateFrequency: 0,
            type: 32,
            calls: 0,
            activeCalls: -1,
            maxWaitTime: 0,
            agentsLoggedIn: 0,
            agentsAvailable: 0,
            queueAgents: [
              {
                organization: MockData.organization,
                login: '91902156',
                firstName: 'User_2156',
                lastName: 'Test',
                phoneNumber: null,
                serviceNumber: '4770238717',
                cid: 39,
                state: 0,
                active: true,
                skillLevel: 6,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '91903248',
                firstName: 'Test_3248',
                lastName: 'user',
                phoneNumber: '4791903248',
                serviceNumber: '4770238717',
                cid: 39,
                state: 1,
                active: false,
                skillLevel: 1,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '91903934',
                firstName: 'Test_3934',
                lastName: 'User',
                phoneNumber: null,
                serviceNumber: '4770238717',
                cid: 39,
                state: 0,
                active: false,
                skillLevel: 5,
                noReplyTime: 20,
                wrapupTime: 20
              }
            ]
          }
        ]
      },
      {
        serviceNumber: {
          number: '4770238871',
          name: 'Svargruppe_78403123',
          pattern: '2'
        },
        queueData: [
          {
            serviceNumber: '4770238871',
            cid: 0,
            name: 'Svargruppe_78403123',
            maxPositions: 0,
            maxTime: 0,
            checkFrequency: 30,
            kickoutTime: 300,
            kickoutNoAgents: 120,
            displayUpdateFrequency: 30,
            type: 3,
            calls: 0,
            activeCalls: -1,
            maxWaitTime: 0,
            agentsLoggedIn: 1,
            agentsAvailable: 1,
            queueAgents: [
              {
                organization: MockData.organization,
                login: '37179231',
                firstName: 'mainnumber',
                lastName: 'ansatte',
                phoneNumber: null,
                serviceNumber: '4770238871',
                cid: 0,
                state: 0,
                active: false,
                skillLevel: 12,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '45918612',
                firstName: 'Fairooz',
                lastName: 'Test',
                phoneNumber: '4745918612',
                serviceNumber: '4770238871',
                cid: 0,
                state: 1,
                active: false,
                skillLevel: 9,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '48391215',
                firstName: 'Test ICE_1215',
                lastName: 'ICE 1215',
                phoneNumber: '4748391215',
                serviceNumber: '4770238871',
                cid: 0,
                state: 1,
                active: false,
                skillLevel: 14,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '90711683',
                firstName: 'Marina',
                lastName: 'Ja',
                phoneNumber: '4790711683',
                serviceNumber: '4770238871',
                cid: 0,
                state: 1,
                active: false,
                skillLevel: 15,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '91900473',
                firstName: 'Test_0473',
                lastName: 'User',
                phoneNumber: null,
                serviceNumber: '4770238871',
                cid: 0,
                state: 0,
                active: false,
                skillLevel: 5,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '91901723',
                firstName: 'Test_1723',
                lastName: 'User',
                phoneNumber: '4791901723',
                serviceNumber: '4770238871',
                cid: 0,
                state: 1,
                active: false,
                skillLevel: 8,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '91902087',
                firstName: 'Test_2087',
                lastName: 'User',
                phoneNumber: null,
                serviceNumber: '4770238871',
                cid: 0,
                state: 0,
                active: false,
                skillLevel: 6,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '91902156',
                firstName: 'User_2156',
                lastName: 'Test',
                phoneNumber: null,
                serviceNumber: '4770238871',
                cid: 0,
                state: 0,
                active: false,
                skillLevel: 10,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '91902493',
                firstName: 'VoLTE_2493',
                lastName: 'Test',
                phoneNumber: '4791902493',
                serviceNumber: '4770238871',
                cid: 0,
                state: 1,
                active: true,
                skillLevel: 2,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '91902604',
                firstName: 'user_2604',
                lastName: 'test',
                phoneNumber: '4791902604',
                serviceNumber: '4770238871',
                cid: 0,
                state: 1,
                active: false,
                skillLevel: 3,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '91902955',
                firstName: 'Test_2955',
                lastName: 'User',
                phoneNumber: '4791902955',
                serviceNumber: '4770238871',
                cid: 0,
                state: 1,
                active: false,
                skillLevel: 18,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '91903248',
                firstName: 'Test_3248',
                lastName: 'user',
                phoneNumber: '4791903248',
                serviceNumber: '4770238871',
                cid: 0,
                state: 1,
                active: false,
                skillLevel: 11,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '91903934',
                firstName: 'Test_3934',
                lastName: 'User',
                phoneNumber: null,
                serviceNumber: '4770238871',
                cid: 0,
                state: 0,
                active: false,
                skillLevel: 13,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '91905392',
                firstName: 'User_5392',
                lastName: 'Test',
                phoneNumber: null,
                serviceNumber: '4770238871',
                cid: 0,
                state: 0,
                active: false,
                skillLevel: 17,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '91906314',
                firstName: 'Telenor_sim',
                lastName: '6314',
                phoneNumber: '4791906314',
                serviceNumber: '4770238871',
                cid: 0,
                state: 1,
                active: false,
                skillLevel: 7,
                noReplyTime: 20,
                wrapupTime: 0
              }
            ]
          },
          {
            serviceNumber: '4770238871',
            cid: 3,
            name: 'Holdqueue',
            maxPositions: 0,
            maxTime: 0,
            checkFrequency: 30,
            kickoutTime: 600,
            kickoutNoAgents: 9999,
            displayUpdateFrequency: 30,
            type: 3,
            calls: 0,
            activeCalls: -1,
            maxWaitTime: 0,
            agentsLoggedIn: 0,
            agentsAvailable: 0,
            queueAgents: []
          },
          {
            serviceNumber: '4770238871',
            cid: 39,
            name: 'CallbackQueue',
            maxPositions: 0,
            maxTime: 0,
            checkFrequency: 0,
            kickoutTime: 0,
            kickoutNoAgents: 0,
            displayUpdateFrequency: 0,
            type: 32,
            calls: 0,
            activeCalls: -1,
            maxWaitTime: 0,
            agentsLoggedIn: 1,
            agentsAvailable: 1,
            queueAgents: [
              {
                organization: MockData.organization,
                login: '37179231',
                firstName: 'mainnumber',
                lastName: 'ansatte',
                phoneNumber: null,
                serviceNumber: '4770238871',
                cid: 39,
                state: 0,
                active: false,
                skillLevel: 12,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '45918612',
                firstName: 'Fairooz',
                lastName: 'Test',
                phoneNumber: '4745918612',
                serviceNumber: '4770238871',
                cid: 39,
                state: 1,
                active: false,
                skillLevel: 9,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '48391215',
                firstName: 'Test ICE_1215',
                lastName: 'ICE 1215',
                phoneNumber: '4748391215',
                serviceNumber: '4770238871',
                cid: 39,
                state: 1,
                active: false,
                skillLevel: 14,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '90711683',
                firstName: 'Marina',
                lastName: 'Ja',
                phoneNumber: '4790711683',
                serviceNumber: '4770238871',
                cid: 39,
                state: 1,
                active: false,
                skillLevel: 15,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '91900473',
                firstName: 'Test_0473',
                lastName: 'User',
                phoneNumber: null,
                serviceNumber: '4770238871',
                cid: 39,
                state: 0,
                active: false,
                skillLevel: 5,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '91901723',
                firstName: 'Test_1723',
                lastName: 'User',
                phoneNumber: '4791901723',
                serviceNumber: '4770238871',
                cid: 39,
                state: 1,
                active: false,
                skillLevel: 8,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '91902087',
                firstName: 'Test_2087',
                lastName: 'User',
                phoneNumber: null,
                serviceNumber: '4770238871',
                cid: 39,
                state: 0,
                active: false,
                skillLevel: 6,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '91902156',
                firstName: 'User_2156',
                lastName: 'Test',
                phoneNumber: null,
                serviceNumber: '4770238871',
                cid: 39,
                state: 0,
                active: false,
                skillLevel: 10,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '91902493',
                firstName: 'VoLTE_2493',
                lastName: 'Test',
                phoneNumber: '4791902493',
                serviceNumber: '4770238871',
                cid: 39,
                state: 1,
                active: true,
                skillLevel: 2,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '91902604',
                firstName: 'user_2604',
                lastName: 'test',
                phoneNumber: '4791902604',
                serviceNumber: '4770238871',
                cid: 39,
                state: 1,
                active: false,
                skillLevel: 3,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '91902955',
                firstName: 'Test_2955',
                lastName: 'User',
                phoneNumber: '4791902955',
                serviceNumber: '4770238871',
                cid: 39,
                state: 1,
                active: false,
                skillLevel: 18,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '91903248',
                firstName: 'Test_3248',
                lastName: 'user',
                phoneNumber: '4791903248',
                serviceNumber: '4770238871',
                cid: 39,
                state: 1,
                active: false,
                skillLevel: 11,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '91903934',
                firstName: 'Test_3934',
                lastName: 'User',
                phoneNumber: null,
                serviceNumber: '4770238871',
                cid: 39,
                state: 0,
                active: false,
                skillLevel: 13,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '91905392',
                firstName: 'User_5392',
                lastName: 'Test',
                phoneNumber: null,
                serviceNumber: '4770238871',
                cid: 39,
                state: 0,
                active: false,
                skillLevel: 17,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '91906314',
                firstName: 'Telenor_sim',
                lastName: '6314',
                phoneNumber: '4791906314',
                serviceNumber: '4770238871',
                cid: 39,
                state: 1,
                active: false,
                skillLevel: 7,
                noReplyTime: 20,
                wrapupTime: 0
              }
            ]
          }
        ]
      },
      {
        serviceNumber: {
          number: '4770238871001',
          name: 'Tastevalg_12',
          pattern: '7'
        },
        queueData: []
      },
      {
        serviceNumber: {
          number: '4778403123',
          name: 'Hoved SIP_IC_4778403123',
          pattern: '1'
        },
        queueData: []
      },
      {
        serviceNumber: {
          number: '4778403123001',
          name: 'Screening',
          pattern: '9'
        },
        queueData: []
      },
      {
        serviceNumber: {
          number: '4778974931',
          name: 'AA Svargrupper IMG 4778974931',
          pattern: '2'
        },
        queueData: [
          {
            serviceNumber: '4778974931',
            cid: 0,
            name: 'AA Svargrupper IMG 4778974931',
            maxPositions: 0,
            maxTime: 0,
            checkFrequency: 30,
            kickoutTime: 30,
            kickoutNoAgents: 120,
            displayUpdateFrequency: 30,
            type: 3,
            calls: 0,
            activeCalls: -1,
            maxWaitTime: 0,
            agentsLoggedIn: 1,
            agentsAvailable: 1,
            queueAgents: [
              {
                organization: MockData.organization,
                login: '37179231',
                firstName: 'mainnumber',
                lastName: 'ansatte',
                phoneNumber: null,
                serviceNumber: '4778974931',
                cid: 0,
                state: 0,
                active: true,
                skillLevel: 6,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '90119372',
                firstName: 'Arne2',
                lastName: 'Testbruker',
                phoneNumber: null,
                serviceNumber: '4778974931',
                cid: 0,
                state: 0,
                active: false,
                skillLevel: 8,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '91903248',
                firstName: 'Test_3248',
                lastName: 'user',
                phoneNumber: '4791903248',
                serviceNumber: '4778974931',
                cid: 0,
                state: 1,
                active: true,
                skillLevel: 2,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '91903934',
                firstName: 'Test_3934',
                lastName: 'User',
                phoneNumber: null,
                serviceNumber: '4778974931',
                cid: 0,
                state: 0,
                active: false,
                skillLevel: 4,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '91923048',
                firstName: 'Test_3048',
                lastName: 'User',
                phoneNumber: null,
                serviceNumber: '4778974931',
                cid: 0,
                state: 0,
                active: true,
                skillLevel: 3,
                noReplyTime: 20,
                wrapupTime: 0
              }
            ]
          },
          {
            serviceNumber: '4778974931',
            cid: 3,
            name: 'Holdqueue',
            maxPositions: 0,
            maxTime: 0,
            checkFrequency: 30,
            kickoutTime: 600,
            kickoutNoAgents: 9999,
            displayUpdateFrequency: 30,
            type: 3,
            calls: 0,
            activeCalls: -1,
            maxWaitTime: 0,
            agentsLoggedIn: 0,
            agentsAvailable: 0,
            queueAgents: []
          },
          {
            serviceNumber: '4778974931',
            cid: 39,
            name: 'CallbackQueue',
            maxPositions: 0,
            maxTime: 0,
            checkFrequency: 0,
            kickoutTime: 0,
            kickoutNoAgents: 0,
            displayUpdateFrequency: 0,
            type: 32,
            calls: 0,
            activeCalls: -1,
            maxWaitTime: 0,
            agentsLoggedIn: 1,
            agentsAvailable: 1,
            queueAgents: [
              {
                organization: MockData.organization,
                login: '37179231',
                firstName: 'mainnumber',
                lastName: 'ansatte',
                phoneNumber: null,
                serviceNumber: '4778974931',
                cid: 39,
                state: 0,
                active: true,
                skillLevel: 6,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '90119372',
                firstName: 'Arne2',
                lastName: 'Testbruker',
                phoneNumber: null,
                serviceNumber: '4778974931',
                cid: 39,
                state: 0,
                active: false,
                skillLevel: 8,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '91903248',
                firstName: 'Test_3248',
                lastName: 'user',
                phoneNumber: '4791903248',
                serviceNumber: '4778974931',
                cid: 39,
                state: 1,
                active: true,
                skillLevel: 2,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '91903934',
                firstName: 'Test_3934',
                lastName: 'User',
                phoneNumber: null,
                serviceNumber: '4778974931',
                cid: 39,
                state: 0,
                active: false,
                skillLevel: 4,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '91923048',
                firstName: 'Test_3048',
                lastName: 'User',
                phoneNumber: null,
                serviceNumber: '4778974931',
                cid: 39,
                state: 0,
                active: true,
                skillLevel: 3,
                noReplyTime: 20,
                wrapupTime: 0
              }
            ]
          }
        ]
      },
      {
        serviceNumber: {
          number: '4778974934',
          name: '4778974934_NewAG',
          pattern: '2'
        },
        queueData: [
          {
            serviceNumber: '4778974934',
            cid: 0,
            name: '4778974934_NewAG',
            maxPositions: 0,
            maxTime: 0,
            checkFrequency: 30,
            kickoutTime: 600,
            kickoutNoAgents: 120,
            displayUpdateFrequency: 30,
            type: 3,
            calls: 0,
            activeCalls: -1,
            maxWaitTime: 0,
            agentsLoggedIn: 2,
            agentsAvailable: 2,
            queueAgents: [
              {
                organization: MockData.organization,
                login: '48391215',
                firstName: 'Test ICE_1215',
                lastName: 'ICE 1215',
                phoneNumber: '4748391215',
                serviceNumber: '4778974934',
                cid: 0,
                state: 1,
                active: false,
                skillLevel: 3,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '91902156',
                firstName: 'User_2156',
                lastName: 'Test',
                phoneNumber: null,
                serviceNumber: '4778974934',
                cid: 0,
                state: 0,
                active: false,
                skillLevel: 5,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '91903248',
                firstName: 'Test_3248',
                lastName: 'user',
                phoneNumber: '4791903248',
                serviceNumber: '4778974934',
                cid: 0,
                state: 1,
                active: true,
                skillLevel: 1,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '91903934',
                firstName: 'Test_3934',
                lastName: 'User',
                phoneNumber: null,
                serviceNumber: '4778974934',
                cid: 0,
                state: 0,
                active: false,
                skillLevel: 6,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '97304585',
                firstName: 'Test ICE',
                lastName: 'ICE Test',
                phoneNumber: '4797304585',
                serviceNumber: '4778974934',
                cid: 0,
                state: 1,
                active: true,
                skillLevel: 4,
                noReplyTime: 20,
                wrapupTime: 0
              }
            ]
          },
          {
            serviceNumber: '4778974934',
            cid: 3,
            name: 'Holdqueue',
            maxPositions: 0,
            maxTime: 0,
            checkFrequency: 30,
            kickoutTime: 600,
            kickoutNoAgents: 9999,
            displayUpdateFrequency: 30,
            type: 3,
            calls: 0,
            activeCalls: -1,
            maxWaitTime: 0,
            agentsLoggedIn: 0,
            agentsAvailable: 0,
            queueAgents: []
          },
          {
            serviceNumber: '4778974934',
            cid: 39,
            name: 'CallbackQueue',
            maxPositions: 0,
            maxTime: 0,
            checkFrequency: 0,
            kickoutTime: 0,
            kickoutNoAgents: 0,
            displayUpdateFrequency: 0,
            type: 32,
            calls: 0,
            activeCalls: -1,
            maxWaitTime: 0,
            agentsLoggedIn: 2,
            agentsAvailable: 2,
            queueAgents: [
              {
                organization: MockData.organization,
                login: '48391215',
                firstName: 'Test ICE_1215',
                lastName: 'ICE 1215',
                phoneNumber: '4748391215',
                serviceNumber: '4778974934',
                cid: 39,
                state: 1,
                active: false,
                skillLevel: 3,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '91902156',
                firstName: 'User_2156',
                lastName: 'Test',
                phoneNumber: null,
                serviceNumber: '4778974934',
                cid: 39,
                state: 0,
                active: false,
                skillLevel: 5,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '91903248',
                firstName: 'Test_3248',
                lastName: 'user',
                phoneNumber: '4791903248',
                serviceNumber: '4778974934',
                cid: 39,
                state: 1,
                active: true,
                skillLevel: 1,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '91903934',
                firstName: 'Test_3934',
                lastName: 'User',
                phoneNumber: null,
                serviceNumber: '4778974934',
                cid: 39,
                state: 0,
                active: false,
                skillLevel: 6,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '97304585',
                firstName: 'Test ICE',
                lastName: 'ICE Test',
                phoneNumber: '4797304585',
                serviceNumber: '4778974934',
                cid: 39,
                state: 1,
                active: true,
                skillLevel: 4,
                noReplyTime: 20,
                wrapupTime: 0
              }
            ]
          }
        ]
      },
      {
        serviceNumber: {
          number: '4778974937',
          name: 'Å svargruppe_04158',
          pattern: '2'
        },
        queueData: [
          {
            serviceNumber: '4778974937',
            cid: 0,
            name: 'Å svargruppe_04158',
            maxPositions: 0,
            maxTime: 0,
            checkFrequency: 30,
            kickoutTime: 600,
            kickoutNoAgents: 120,
            displayUpdateFrequency: 30,
            type: 3,
            calls: 0,
            activeCalls: -1,
            maxWaitTime: 0,
            agentsLoggedIn: 0,
            agentsAvailable: 0,
            queueAgents: []
          },
          {
            serviceNumber: '4778974937',
            cid: 3,
            name: 'Holdqueue',
            maxPositions: 0,
            maxTime: 0,
            checkFrequency: 30,
            kickoutTime: 600,
            kickoutNoAgents: 9999,
            displayUpdateFrequency: 30,
            type: 3,
            calls: 0,
            activeCalls: -1,
            maxWaitTime: 0,
            agentsLoggedIn: 0,
            agentsAvailable: 0,
            queueAgents: []
          },
          {
            serviceNumber: '4778974937',
            cid: 39,
            name: 'CallbackQueue',
            maxPositions: 0,
            maxTime: 0,
            checkFrequency: 0,
            kickoutTime: 0,
            kickoutNoAgents: 0,
            displayUpdateFrequency: 0,
            type: 32,
            calls: 0,
            activeCalls: -1,
            maxWaitTime: 0,
            agentsLoggedIn: 0,
            agentsAvailable: 0,
            queueAgents: []
          }
        ]
      },
      {
        serviceNumber: {
          number: '4778974938',
          name: 'Svargruppe_91906218',
          pattern: '2'
        },
        queueData: [
          {
            serviceNumber: '4778974938',
            cid: 0,
            name: 'Svargruppe_91906218',
            maxPositions: 0,
            maxTime: 0,
            checkFrequency: 30,
            kickoutTime: 600,
            kickoutNoAgents: 120,
            displayUpdateFrequency: 30,
            type: 3,
            calls: 0,
            activeCalls: -1,
            maxWaitTime: 0,
            agentsLoggedIn: 1,
            agentsAvailable: 1,
            queueAgents: [
              {
                organization: MockData.organization,
                login: '91906218',
                firstName: 'Test_6218',
                lastName: 'User',
                phoneNumber: '4791906218',
                serviceNumber: '4778974938',
                cid: 0,
                state: 1,
                active: true,
                skillLevel: 1,
                noReplyTime: 20,
                wrapupTime: 0
              }
            ]
          },
          {
            serviceNumber: '4778974938',
            cid: 3,
            name: 'Holdqueue',
            maxPositions: 0,
            maxTime: 0,
            checkFrequency: 30,
            kickoutTime: 600,
            kickoutNoAgents: 9999,
            displayUpdateFrequency: 30,
            type: 3,
            calls: 0,
            activeCalls: -1,
            maxWaitTime: 0,
            agentsLoggedIn: 0,
            agentsAvailable: 0,
            queueAgents: []
          },
          {
            serviceNumber: '4778974938',
            cid: 39,
            name: 'CallbackQueue',
            maxPositions: 0,
            maxTime: 0,
            checkFrequency: 0,
            kickoutTime: 0,
            kickoutNoAgents: 0,
            displayUpdateFrequency: 0,
            type: 32,
            calls: 0,
            activeCalls: -1,
            maxWaitTime: 0,
            agentsLoggedIn: 1,
            agentsAvailable: 1,
            queueAgents: [
              {
                organization: MockData.organization,
                login: '91906218',
                firstName: 'Test_6218',
                lastName: 'User',
                phoneNumber: '4791906218',
                serviceNumber: '4778974938',
                cid: 39,
                state: 1,
                active: true,
                skillLevel: 1,
                noReplyTime: 20,
                wrapupTime: 0
              }
            ]
          }
        ]
      },
      {
        serviceNumber: {
          number: '4778974972',
          name: 'Svargruppe_91903884',
          pattern: '2'
        },
        queueData: [
          {
            serviceNumber: '4778974972',
            cid: 0,
            name: 'Svargruppe_91903884',
            maxPositions: 0,
            maxTime: 0,
            checkFrequency: 30,
            kickoutTime: 600,
            kickoutNoAgents: 120,
            displayUpdateFrequency: 30,
            type: 3,
            calls: 0,
            activeCalls: -1,
            maxWaitTime: 0,
            agentsLoggedIn: 2,
            agentsAvailable: 2,
            queueAgents: [
              {
                organization: MockData.organization,
                login: '91903884',
                firstName: 'Test_91903884',
                lastName: 'User',
                phoneNumber: '4791903884',
                serviceNumber: '4778974972',
                cid: 0,
                state: 1,
                active: true,
                skillLevel: 4,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '91906218',
                firstName: 'Test_6218',
                lastName: 'User',
                phoneNumber: '4791906218',
                serviceNumber: '4778974972',
                cid: 0,
                state: 1,
                active: true,
                skillLevel: 3,
                noReplyTime: 20,
                wrapupTime: 0
              }
            ]
          },
          {
            serviceNumber: '4778974972',
            cid: 3,
            name: 'Holdqueue',
            maxPositions: 0,
            maxTime: 0,
            checkFrequency: 30,
            kickoutTime: 600,
            kickoutNoAgents: 9999,
            displayUpdateFrequency: 30,
            type: 3,
            calls: 0,
            activeCalls: -1,
            maxWaitTime: 0,
            agentsLoggedIn: 0,
            agentsAvailable: 0,
            queueAgents: []
          },
          {
            serviceNumber: '4778974972',
            cid: 39,
            name: 'CallbackQueue',
            maxPositions: 0,
            maxTime: 0,
            checkFrequency: 0,
            kickoutTime: 0,
            kickoutNoAgents: 0,
            displayUpdateFrequency: 0,
            type: 32,
            calls: 0,
            activeCalls: -1,
            maxWaitTime: 0,
            agentsLoggedIn: 2,
            agentsAvailable: 2,
            queueAgents: [
              {
                organization: MockData.organization,
                login: '91903884',
                firstName: 'Test_91903884',
                lastName: 'User',
                phoneNumber: '4791903884',
                serviceNumber: '4778974972',
                cid: 39,
                state: 1,
                active: true,
                skillLevel: 4,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '91906218',
                firstName: 'Test_6218',
                lastName: 'User',
                phoneNumber: '4791906218',
                serviceNumber: '4778974972',
                cid: 39,
                state: 1,
                active: true,
                skillLevel: 3,
                noReplyTime: 20,
                wrapupTime: 0
              }
            ]
          }
        ]
      },
      {
        serviceNumber: {
          number: '4778974973',
          name: 'QueueOverflowTest',
          pattern: '2'
        },
        queueData: [
          {
            serviceNumber: '4778974973',
            cid: 0,
            name: 'Queue',
            maxPositions: 0,
            maxTime: 0,
            checkFrequency: 30,
            kickoutTime: 300,
            kickoutNoAgents: 30,
            displayUpdateFrequency: 30,
            type: 3,
            calls: 0,
            activeCalls: -1,
            maxWaitTime: 0,
            agentsLoggedIn: 0,
            agentsAvailable: 0,
            queueAgents: [
              {
                organization: MockData.organization,
                login: '90119372',
                firstName: 'Arne2',
                lastName: 'Testbruker',
                phoneNumber: null,
                serviceNumber: '4778974973',
                cid: 0,
                state: 0,
                active: false,
                skillLevel: 2,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '91902156',
                firstName: 'User_2156',
                lastName: 'Test',
                phoneNumber: null,
                serviceNumber: '4778974973',
                cid: 0,
                state: 0,
                active: true,
                skillLevel: 3,
                noReplyTime: 20,
                wrapupTime: 0
              },
              {
                organization: MockData.organization,
                login: '99286866',
                firstName: 'Kjartan',
                lastName: 'Rydland',
                phoneNumber: null,
                serviceNumber: '4778974973',
                cid: 0,
                state: 0,
                active: false,
                skillLevel: 4,
                noReplyTime: 20,
                wrapupTime: 0
              }
            ]
          }
        ]
      },
      {
        serviceNumber: {
          number: '4791906218',
          name: 'MH2',
          pattern: '1'
        },
        queueData: []
      }
    ];
  }
}
